export const API_URL = (process.env.REACT_APP_API_URL || 'https://kisandailyfresh.in').replace(/\/+$/, '');

export const buildApiUrl = (path = '') => {
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedPath = String(path).replace(/^\/+/, '');
  return normalizedPath ? `${API_URL}/${normalizedPath}` : API_URL;
};

export const buildAssetUrl = (assetPath) => {
  if (!assetPath) return null;
  if (/^https?:\/\//i.test(assetPath)) return assetPath;
  return buildApiUrl(assetPath);
};
